export default __webpack_public_path__ + "static/media/download-sm.24abfba0.svg";